export default {
  unskilled: ({ unskilled }) => unskilled,
  emptyExperience: ({ experiencies }) => experiencies.length == 0,
  experiencesIsEmpty: ({ experiencies }) => experiencies.length === 0,
};
